import { render, staticRenderFns } from "./PredictionTuku.vue?vue&type=template&id=464f25fe&scoped=true&"
import script from "./PredictionTuku.vue?vue&type=script&lang=js&"
export * from "./PredictionTuku.vue?vue&type=script&lang=js&"
import style0 from "./PredictionTuku.vue?vue&type=style&index=0&id=464f25fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464f25fe",
  null
  
)

export default component.exports